<template>
    <div :class="[$style['mds-pagination'], classObject, sizeClass]" :data-mds-version="version">
        <div :class="[$style['mds-pagination__left']]">
            <div :class="[$style['mds-pagination__page-select']]">
                {{ labels.page }}
                <mds-select
                    ref="pageSelect"
                    :class="[$style['mds-pagination__select']]"
                    v-model="pageSelected"
                    :on-dark="onDark"
                    label="page select"
                    hidden-label
                    :options="pageOptions"
                    :size="size"
                />
                {{ labels.of }} {{ totalPages }}
            </div>
            <div :class="[$style['mds-pagination__buttons']]">
                <mds-button-container>
                    <mds-button
                        ref="prevButton"
                        :text="prevText"
                        :on-dark="onDark"
                        :disabled="onFirstPage"
                        icon="angle-left"
                        :variation="iconOnlyButton"
                        :size="size"
                        @click="prevPage"
                    />
                    <mds-button
                        ref="nextButton"
                        :text="nextText"
                        :disabled="onLastPage"
                        :on-dark="onDark"
                        :icon="iconOnly ? 'angle-right' : ''"
                        :icon-right="iconOnly ? '' : 'angle-right'"
                        :variation="iconOnlyButton"
                        :size="size"
                        @click="nextPage"
                    />
                </mds-button-container>
            </div>
            <div v-if="showItemsInfo" :class="[$style['mds-pagination__viewing-info']]">
                {{ labels.viewing }} {{ firstItem }} {{ labels.to }} {{ lastItem }} {{ labels.of }} {{ totalItems }}
            </div>
        </div>
        <div :class="[$style['mds-pagination__right']]">
            <div :class="[$style['mds-pagination__show-items']]" v-if="showItemsSelect">
                {{ labels.show }}
                <mds-select
                    ref="sizeSelect"
                    :class="[$style['mds-pagination__select']]"
                    label="row count select"
                    hidden-label
                    :on-dark="onDark"
                    :options="pageSizeOptions"
                    v-model="itemsSelected"
                    :size="size"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import MdsPaginationProps from './pagination_props.js';
    import MdsSelect from '@mds/select';
    import { MdsButton, MdsButtonContainer } from '@mds/button';

    export default {
        name: 'MdsPagination',
        props: MdsPaginationProps,
        components: {
            MdsButton,
            MdsButtonContainer,
            MdsSelect,
        },
        computed: {
            sizeClass() {
                return this.$style[`mds-pagination--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
            onFirstPage() {
                return parseInt(this.pageSelected) === 1;
            },
            onLastPage() {
                return parseInt(this.pageSelected) === this.totalPages;
            },
            pageOptions() {
                const options = [];
                const numPages = this.totalPages;
                for (let i = 1; i <= numPages; i++) {
                    options.push(i);
                }
                return this.covertArrayOptions(options);
            },
            totalPages() {
                return Math.ceil(this.totalItems / this.rowCount);
            },
            pageSizeOptions() {
                return this.covertArrayOptions(this.pageSizes);
            },
            iconOnlyButton() {
                return this.iconOnly ? 'icon-only' : 'flat';
            },
            lastItem() {
                return this.rowCount * parseInt(this.pageSelected) > this.totalItems
                    ? this.totalItems
                    : this.rowCount * parseInt(this.pageSelected);
            },
            firstItem() {
                let pageFirst = this.rowCount * (parseInt(this.pageSelected) - 1);
                pageFirst = pageFirst + 1 > this.totalItems ? pageFirst : pageFirst + 1;

                return parseInt(this.pageSelected) > 1 ? pageFirst : 1;
            },
            rowCount() {
                return parseInt(this.itemsSelected) === -1 || this.itemsSelected > this.totalItems
                    ? this.totalItems
                    : this.itemsSelected;
            },
        },
        data() {
            return {
                pageSelected: this.page,
                itemsSelected: this.pageSizes.includes(this.pageSize) ? this.pageSize : this.pageSizes[0],
                labels: {
                    of: 'of',
                    page: 'Page',
                    show: 'Show',
                    to: 'to',
                    viewing: 'Viewing',
                },
            };
        },
        watch: {
            itemsSelected() {
                this.pageSelected = 1;
                if (this.pageSelected === 1) {
                    this.emitPageChangeEvent();
                }
            },
            pageSelected() {
                this.emitPageChangeEvent();
            },
            page(newPage) {
                this.pageSelected = newPage;
            },
        },
        methods: {
            covertArrayOptions(arr) {
                const optArray = [];
                // page size options array converted to options for select
                arr.forEach(element => {
                    const opt = {
                        text: element === -1 ? 'All' : element,
                        value: element,
                    };
                    optArray.push(opt);
                });

                return optArray;
            },
            emitPageChangeEvent() {
                this.$emit('mds-pagination-page-changed', {
                    page: parseInt(this.pageSelected),
                    pageSize: parseInt(this.itemsSelected),
                    firstItem: this.firstItem,
                    lastItem: this.lastItem,
                });
            },
            prevPage() {
                this.$emit('mds-pagination-to-prev');
                if (!this.onFirstPage) {
                    this.pageSelected = parseInt(this.pageSelected) - 1;
                }
            },
            nextPage() {
                this.$emit('mds-pagination-to-next');
                if (!this.onLastPage) {
                    this.pageSelected = parseInt(this.pageSelected) + 1;
                }
            },
        },
    };
</script>

<style lang="scss" module>
    @import './pagination.scss';
</style>
